import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import BackTop from '@/components/base/BackTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SectionTitle from '@/components/base/SectionTitle';
import ArticleCard from '@/components/feature/ArticleCard';
import { cpLines } from '@/mocks/cps';
import { articles } from '@/mocks/articles';
import { Link } from 'react-router-dom';

const toneBar = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};
const toneBadge = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-900',
};

const pageSchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '师兄啊师兄CP线专题',
  url: 'https://pxwfrw.cn/cp',
  description: '师兄啊师兄CP线发展脉络与师兄师姐互动名场面全梳理。',
  inLanguage: 'zh-CN',
  mainEntity: {
    '@type': 'ItemList',
    itemListElement: cpLines.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.name,
      description: c.summary,
    })),
  },
};

export default function Cp() {
  const cpArticles = articles.filter((a) => a.category === 'cp').slice(0, 3);

  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }} />
      <Header />
      <main className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: 'CP线专题' }]} />
        <header className="mb-8 md:mb-12">
          <h1 className="font-heading text-3xl font-black tracking-wide text-foreground-950 md:text-4xl">
            CP线专题
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
            师兄师姐互动名场面、CP 线发展脉络全收录。从官配主线到江湖知己，每一条线都整理好了发展脉络与高甜名场面，
            快来看看你磕的那对进度如何。
          </p>
        </header>

        <section aria-label="CP线梳理">
          <div className="flex flex-col gap-6">
            {cpLines.map((cp) => (
              <article
                key={cp.id}
                className="grid grid-cols-1 gap-6 rounded-xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-200 md:p-7 lg:grid-cols-[1fr_1.2fr]"
              >
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`whitespace-nowrap rounded-md px-2.5 py-1 text-xs ${toneBadge[cp.tone]}`}>
                      {cp.status}
                    </span>
                    <span className="whitespace-nowrap text-sm font-medium text-foreground-500">热度 {cp.intensity}%</span>
                  </div>
                  <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{cp.name}</h2>
                  <p className="font-seal mt-1 text-xl text-primary-600">{cp.pair}</p>
                  <p className="mt-1 text-sm text-foreground-500">{cp.tagline}</p>
                  <div className="mt-4 h-1.5 w-full max-w-xs overflow-hidden rounded-full bg-background-200">
                    <div className={`h-full rounded-full ${toneBar[cp.tone]}`} style={{ width: `${cp.intensity}%` }} />
                  </div>
                  <p className="mt-4 text-sm leading-7 text-foreground-600">{cp.summary}</p>
                </div>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">高甜名场面</h3>
                  <ul className="mt-3 space-y-3">
                    {cp.moments.map((m) => (
                      <li key={m} className="flex items-start gap-2.5 rounded-lg bg-background-100/70 p-3 text-sm leading-6 text-foreground-700">
                        <i className={`mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-xs text-background-50 ${toneBar[cp.tone]}`}>
                          <i className="ri-heart-3-fill text-[10px]" />
                        </i>
                        <span>{m}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section aria-label="CP专题文章" className="mt-16 md:mt-20">
          <SectionTitle
            mark="深度"
            title="CP专题深度文章"
            subtitle="把糖点拆开细看，从发展脉络到名场面逐帧复盘，越品越甜。"
          />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {cpArticles.map((a) => (
              <ArticleCard key={a.id} article={a} />
            ))}
          </div>
        </section>

        <section aria-label="更多内容" className="mt-14 rounded-xl bg-background-100/70 p-6 md:p-8">
          <div className="flex flex-col items-start justify-between gap-4 lg:flex-row lg:items-center">
            <div>
              <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">还想看更多互动名场面？</h2>
              <p className="mt-1 text-sm text-foreground-600">师门日常合集里，藏着更多同门情谊的高甜片段。</p>
            </div>
            <Link to="/daily" className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600">
              去师门日常
            </Link>
          </div>
        </section>
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}